export const actionTypes: any = {
  GET_AUDIT_TRAIL_START: 'GET_AUDIT_TRAIL_START',
  GET_AUDIT_TRAIL_SUCCESS: 'GET_AUDIT_TRAIL_SUCCESS',
  GET_AUDIT_TRAIL_FINISH: 'GET_AUDIT_TRAIL_FINISH',
  GET_AUDIT_TRAIL_FILTER_OPTIONS_START: 'GET_AUDIT_TRAIL_FILTER_OPTIONS_START',
  GET_AUDIT_TRAIL_FILTER_OPTIONS_SUCCESS: 'GET_AUDIT_TRAIL_FILTER_OPTIONS_SUCCESS',
  GET_AUDIT_TRAIL_FILTER_OPTIONS_FINISH: 'GET_AUDIT_TRAIL_FILTER_OPTIONS_FINISH',
}
